import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findCustomerStatus = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/customer_status?`+params,
        method: 'GET'
    })
}

export const addCustomerStatus = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/customer_status`,
        method: 'POST',
        data: data
    })
}

export const findCustomerStatusChoose = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/customer_status/choose`,
        method: 'GET'
    })
}

export const editCustomerStatus = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/customer_status`,
        method: 'PUT',
        data: data
    })
}

export const delCustomerStatus = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/customer_status/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}